"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const EditIcon = (props) => {
    const { loading, className, tooltipDirection, onClick, forSelect } = props;
    return ((0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: '\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0', direction: tooltipDirection, forSelect: forSelect, children: (0, jsx_runtime_1.jsx)("i", { onClick: onClick, className: `${loading ? 'm-2 spinner ' : ''}la la-edit pointer ${className || 'btn btn-sm btn-clean'}` }) }));
};
exports.default = EditIcon;
